import React from 'react';
import { Text } from '@chakra-ui/react';
import moment from 'moment-jalaali';

/**
 * کامپوننت نمایش تاریخ شمسی
 * @param {Object} props - props کامپوننت
 * @param {string} props.date - تاریخ میلادی
 * @param {string} props.format - فرمت نمایش (پیش‌فرض: jYYYY/jMM/jDD)
 * @param {boolean} props.showTime - نمایش زمان (پیش‌فرض: false)
 * @param {Object} props.textProps - props برای کامپوننت Text
 */
const JalaliDateDisplay = ({ 
  date, 
  format = 'jYYYY/jMM/jDD',
  showTime = false,
  textProps = {},
  ...props 
}) => {
  
  if (!date) {
    return <Text {...textProps} {...props}>-</Text>;
  }

  try {
    // اگر تاریخ به صورت شمسی string است، مستقیماً نمایش دهیم
    if (typeof date === 'string' && date.includes('/')) {
      return <Text {...textProps} {...props}>{date}</Text>;
    }
    
    // تبدیل تاریخ میلادی به شمسی
    let jalaliDate = moment(date).format(format);
    
    // اضافه کردن زمان اگر درخواست شده باشد
    if (showTime) {
      const time = moment(date).format('HH:mm');
      jalaliDate = `${jalaliDate} ${time}`;
    }
    
    return <Text {...textProps} {...props}>{jalaliDate}</Text>;
  } catch (error) {
    console.error('Error converting date to Jalali:', error);
    return <Text {...textProps} {...props}>{date || '-'}</Text>;
  }
};

export default JalaliDateDisplay; 